import {
    SAVE_EXTERNAL_USER_DEVICE_DETAILS,
    SAVE_IMAGES_FROM_SKILL_INSIGHT_APP
} from '../redux/actions/ExternalUser/actionExternalUserTypes';
import {UPDATE_USER_PREFERENCE} from "../redux/actions/User/actionTypes";

const URLs = {
    // User's API's
    GET_USER: 'Assesor/GetUserByQID',
    EDIT_USER: 'Admin/UpdateStatusForUser',
    SEND_EMAIL: 'Admin/SendEmail',
    SEND_USER_EMAIL: 'Admin/SendMailForUser',
    GET_SELF_ASSESSMENT_SCREEN: 'UserAnalysis/SelfIndex',
    GET_CURRENT_CYCLE_DETAILS : 'Admin/GetCycleCurrentDetails',
    GET_EMAIL_TYPES:   'Admin/Email',
    GET_WELCOME_EMAIL_PREVIEW: 'Admin/WelcomeEmailPreview',
    GET_USER_MANAGEMENT: 'Admin/UserManagement',
    GET_ASSESSMENT_CYCLES: 'Analysis/AssessmentCycle',
    GET_ASSESSMENT_CYCLES_LIST: 'Admin/GetAssessmentCycle',
    SET_ASSESSMENT_CYCLES: 'Analysis/SaveAssessmentCycle',
    GET_ASSESSMENT_CYCLE: 'Analysis/GetAssessmentCycleDetails',
    GET_QUESTION_BANKS: 'Analysis/EvaluationQuestion',
    DELETE_QUESTION_BANKS: 'Analysis/DeleteQuestion',
    SET_QUESTION_BANK: 'Analysis/SaveQuestion',
    GET_QUESTION_BANK: 'Analysis/GetAssessmentCategoryQuestionDetails',
    GET_ANALYTICS_REPORT_LIST: 'Analytics/ReportList',
    GET_ANALYTICS_ANALYTICS_REPORT: 'Analytics/AnalyticsReport',
    GET_ASSESSOR_EMPLOYEE_MAPPING: 'Assesor/GetAssesseorEmployeeMapping',
    GET_USER_BY_ASSESSOR: 'Assesor/GetUserByAssessorID',
    UPDATE_ASSESSOR: 'Assesor/UpdateAssesorForUser',
    REMOVE_ASSESSOR: 'Assesor/RemoveAssesorForUser',
    GET_EXTERNAL_CANDIDATE_REPORT: 'Reports/ExternalCandidateReport',
    GET_EXPORT_FILE: 'Reports/DownloadExternalCandidateReport',
    GET_TECHNICAL_ASSESSMENTS: 'Assessment/GetAssessment',
    SAVE_TECHNICAL_ASSESSMENT: 'Assessment/SaveAssessment',
    GET_TECHNICAL_ASSESSMENT_DETAILS: 'Assessment/GetAssessmentDetails',
    GET_USER_LIST: 'UserAnalysis/UsersList',
    GET_CYCLE_LIST: 'UserAnalysis/CycleList',
    GET_USER_ANALYSIS: 'UserAnalysis/GetUserAnalysisView',
    GET_CURRENT_CYCLE_STATUS: 'UserAnalysis/GetCurrentCycleStatus',
    GET_ASSESSOR_FEEDBACK: 'UserAnalysis/GetAllAssessorCategoryFeedbacks',
    GET_USER_PROFICIENCYLEVEL: 'UserAnalysis/GetUserProficiencyLevel',
    GET_SCORE_DETAILS: 'UserAnalysis/GetScoreDetails',
    GET_CURRENT_RESPONSE_DATA: 'UserAnalysis/LoadCurrentResponseDataForUser',
    SAVE_RESPONSE: 'UserAnalysis/SaveResponse',
    GET_SELF_ASSESSMENT_REPORT: 'Reports/SelfAssessmentReport',
    GET_SELF_EXPORT_FILE: 'Reports/DownloadSelfAssessmentReport',
    GET_CYCLE_DROPDOWN_VALUE: 'Reports/CycleComparisonReport',
    GET_CYCLE_COMPARE: 'Reports/AssessmentReportComparison',
    GET_EXPORT_DOWNLOAD_COMPARE: 'Reports/DownloadAssessmentReportComparisonReport',
    GET_ASSESSMENT_CYCLES_REPORT: 'Reports/AssessmentCycleReportOrder',
    GET_ASSESSMENT_USER_REPORT: 'Reports/AssessmentCycleUserReport',
    GET_ASSESSMENT_DETAILS_REPORT: 'Reports/AssessmentCycleDetailReport',
    GET_ASSESSMENT_DETAILS_EXPORT: 'Reports/DownloadAssessmentCycleDetailReport',
    GET_ASSESSMENT_SKILL_BASED_REPORT: 'Reports/SkillBasedAssessmentCycleReport',
    GET_ASSESSMENT_SKILL_BASED_EXPORT: 'Reports/DownloadSkillBasedAssessmentCycleReport',
    GET_ASSESSMENT_USER_BASED_EXPORT: 'Reports/ExportAssessmentCycleUser',
    GET_MANAGE_EMPLOYEE: 'Admin/ManageEmployee',
    SET_MANAGE_EMPLOYEE: 'Admin/SaveEmployees',
    UPDATE_MANAGE_EMPLOYEE: 'Admin/UpdateEmployee',
    GET_ALL_EMPLOYEES: '/Admin/Employees',
    SET_MANAGE_EMPLOYEE_CYCLE_DROPDOWN: 'Admin/MapCycleForUser',
    SET_MANAGE_EMPLOYEE_UPDATE_STATUS: 'Admin/UpdateStatusForUser',
    SET_MANAGE_EMPLOYEE_UPDATE_MANAGER: 'Admin/UpdateManagerForUser',
    ADMIN_RESET_EMPLOYEE_ASSESSMENT: 'Admin/ResetEmployeeAssessment',
    ADMIN_RESET_EMPLOYEE_ASSESSMENT_INSTANCES: 'Admin/ResetEmployeeAssessmentInstances',
    GET_MANAGE_ASSESSOR: 'Assesor/ManageAssessors',
    SET_MANAGE_ASSESSOR: 'Assesor/SaveIsAssessor',
    GET_MANAGE_ASSESSOR_UPDATE: 'Assesor/GetUserDetails',
    GET_MANAGE_SKILL: 'Admin/GetAllSkills',
    SET_MANAGE_SKILL: 'Admin/SaveSkill',
    DELETE_MANAGE_SKILL: 'Admin/DeleteSkill',
    GET_MANAGE_SKILLSDATA: 'Admin/GetSkillDetails',
    GET_MANAGE_EMPLOYEE_CYCLES: 'Admin/ManageEmployeeCycle',
    GET_MANAGE_EXTERNALUSERS: 'Admin/UserManagement',
    GET_EXTERNAL_REPORT: 'Reports/DownloadCandidateReport',
    GET_SELF_REPORT: 'Reports/GetSelfAssessmentReportDetails',
    CHECK_USER_EXISTS: 'Admin/CheckUserDetailsWithMail',
    SAVE_USER: 'Admin/SaveUser',
    NOTIFY_USER: 'Dashboard/GetAllNotificationForUser',
    SET_EXTERNAL_USER: 'User/SaveExternalUserDetails',
    GET_EXTERNAL_USER: 'User/Profile',
    GET_MASTER_CONSENT_USER: 'Consent/GetAllMasterConsent',
    GET_CONSENT_DETAILS_ID: 'Consent/GetConsentDetailsById',
    SET_CONSENT_DETAILS: 'Consent/SaveUserConsent',
    SET_USER_IMAGE: 'User/AnalyzeUserImage',
    GET_EVALUTION_USER: 'User/Evaluation',
    GET_EVALUTION_QUESTION: 'User/Assessment',
    
    TAKE_ASSESSMENT: 'FillAssessment/TakeAssessment',
    TAKE_SELF_ASSESSMENT: 'FillAssessment/TakeSelfAssessment',
    RESET_EXAM_PARAMETERS: '/UserAnalysis/ResetExam',
    // GET_ATTENDED_QUESTION_COUNT: 'FillAssessment/GetAleadyAttendedQuestionCount',

    /** Python SkillInsight API: post-assessment candidate feedback (User/* matches external assessment APIs) */
    POST_ASSESSMENT_FEEDBACK: 'User/AssessmentFeedback',
    // To save Assessment Response for external user
    SAVE_ASSESSMENT_RESPONSE_EXTERNAL: 'User/SaveAssessmentResponse',
    SAVE_EVALUTION_QUESTION: 'User/SaveAssessmentResponse',
    // To save Assessment Response for internal user
    SAVE_ASSESSMENT_RESPONSE_INTERNAL: 'FillAssessment/SaveAssessmentResponse',
    // To save question for internal user
    SAVE_INTERNAL_QUESTION: 'FillAssessment/SaveQuestion',
    // To save question for external user
    SAVE_EXTERNAL_QUESTION: 'User/SaveQuestion', 

    
    SET_QUESTION: 'User/SaveQuestion',  // To save question for external user

    SAVE_EXTERNAL_USER_DEVICE_DETAILS: 'User/SaveExternaluserDeviceDetails',
    SAVE_IMAGES_FROM_SKILL_INSIGHT_APP: 'File/SaveImagesFromSkillInsightApp',
    SET_EXTERNAL_IMAGE_STORE: 'User/UpdateExternalImageStore',
    GET_APPROVE_REVIEW_MODIFICATIONS: '/Bank/QbrAdminList',
    GET_USER_MODIFICATIONS: '/Bank/QbrAdminUser',
    GET_QUESTION_DETAILS_FOR_PREVIEW: '/Bank/GetQuestionDetailsForPreview',
    DELETE_QUESTION: '/Bank/UpdateAdminReview',
    SEND_SME_EMAIL: '/Bank/SentSMEEmail',
    DELETE_ATTACHMENT: 'UserAnalysis/DeleteAttachment',
    DOWNLOAD_ATTACHMENT: 'UserAnalysis/DownloadFile',
    GET_QBRCYCLELIST: '/UserAnalysis/QbrCycleList',
    GET_QBRREVIEW_DATA: 'Bank/QBReview',
    SET_SAVEQUESTION: 'Bank/SaveQuestion',
    GET_TEXTSUGGESTION: 'Bank/GetAITextSuggestion',
    GET_CURRENT_AND_PREVIOUS_QUESTION: 'Bank/GetCurrentAndPreviousQuestion',
    GET_QUESTION_DETAILS_PREVIEW: 'Bank/GetQuestionDetailsForPreview',
    SAVE_QUESTION_REVIEW: 'Bank/SaveQuestionReview',
    GET_QUESTION_REVIEW: 'Bank/EditQuestion',
    GET_TECHNICAL_QUESTION_BANK: 'Bank/GetQuestionBank',
    GET_EDIT_QUESTION_DATA: '/Bank/EditQuestion',
    SAVE_QUESTIONS_FROM_EXCEL: '/Bank/SaveQuestionBank',
    DELETE_QUESTION_TQB: '/Bank/DeleteQuestion',
    GET_MANAGE_SME: '/Bank/ManageSMEMapping',
    SAVE_MANAGE_SME: '/Bank/AddDeleteManageSMEMapping',
    GET_EXTERNAL_USER_ENCRYPTED_EMAIL: 'Admin/EncryptString',
    SEND_MAIL_FOR_HR: 'User/SendMailForHR',
    GET_USER_DETAILS: 'Dashboard/GetDashboard',
    GET_USER_PROFILE: 'Dashboard/UserProfile',
    UPDATE_USER_PREFERENCES: 'Dashboard/SaveUserPreference',
    SUBMIT_SKILL_CHANGE_REQUEST: 'Dashboard/SubmitSkillChangeRequest',
    GET_SKILL_CHANGE_REQUEST_FOR_REVIEW: 'Dashboard/GetSkillChangeRequestForReview',
    REVIEW_SKILL_CHANGE_REQUEST: 'Dashboard/ReviewSkillChangeRequest',
    SAVE_CYCLE_CHANGES: 'Admin/SaveCycleChanges',
    GET_USER_NOTIFICATIONS: 'Dashboard/GetAllNotificationForUser',
    DELETE_USER_NOTIFICATION: 'Dashboard/DeleteNotification',
    GET_SELF_CYCLE:'UserAnalysis/SelfCycleList',
    RESET_ASSESSMENT:'UserAnalysis/ResetExam',
    TAKE_SELF_ASSESSMENT: 'FillAssessment/TakeSelfAssessment',
    TAKE_SELF_ASSESSMENT: 'FillAssessment/TakeSelfAssessment',
};

export default URLs;
